// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Setting List Styles (Welcome Page) */

.ai-setting-list-container {
    max-width: 100%;
    height: 100%;
    padding: 20px;
    background: #f8f9fa;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* Header */
.ai-setting-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 16px 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
}

.ai-setting-list-header h3 {
    margin: 0;
    color: #333;
    font-size: 20px;
}

/* Buttons */
.ai-setting-list-button {
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.ai-setting-list-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.ai-setting-list-button--primary {
    background: #007bff;
    color: white;
}

.ai-setting-list-button--primary:hover:not(:disabled) {
    background: #0056b3;
}

.ai-setting-list-button--view {
    background: #17a2b8;
    color: white;
    padding: 6px 12px;
    font-size: 12px;
}

.ai-setting-list-button--view:hover:not(:disabled) {
    background: #138496;
}

.ai-setting-list-button--edit {
    background: #28a745;
    color: white;
    padding: 6px 12px;
    font-size: 12px;
}

.ai-setting-list-button--edit:hover:not(:disabled) {
    background: #1e7e34;
}

.ai-setting-list-button--delete {
    background: #dc3545;
    color: white;
    padding: 6px 12px;
    font-size: 12px;
}

.ai-setting-list-button--delete:hover:not(:disabled) {
    background: #c82333;
}

/* Error and Loading States */
.ai-setting-list-error {
    background: #f8d7da;
    color: #721c24;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ai-setting-list-retry {
    background: #dc3545;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.ai-setting-list-loading {
    text-align: center;
    padding: 40px 20px;
    background: white;
    border-radius: 8px;
}

.ai-setting-list-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 12px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.ai-setting-list-empty {
    text-align: center;
    padding: 40px 20px;
    background: white;
    border-radius: 8px;
    color: #666;
}

.ai-setting-list-empty-icon {
    font-size: 36px;
    margin-bottom: 12px;
}

/* Scrollable content wrapper */
.ai-setting-list-content-wrapper {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e0 #f8f9fa;
}

.ai-setting-list-content-wrapper::-webkit-scrollbar {
    width: 8px;
}

.ai-setting-list-content-wrapper::-webkit-scrollbar-track {
    background: #f8f9fa;
}

.ai-setting-list-content-wrapper::-webkit-scrollbar-thumb {
    background-color: #cbd5e0;
    border-radius: 4px;
}

.ai-setting-list-content-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: #a0aec0;
}

/* Settings Grid */
.ai-setting-list-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
    padding-bottom: 20px;
}

.ai-setting-list-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.ai-setting-list-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.ai-setting-list-card-header {
    padding: 16px;
    border-bottom: 1px solid #e9ecef;
    background: #f8f9fa;
}

.ai-setting-list-card-header h4 {
    margin: 0;
    color: #333;
    font-size: 16px;
}

.ai-setting-list-card-content {
    padding: 16px;
    flex: 1;
    overflow-y: auto;
}

.ai-setting-list-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-size: 13px;
}

.ai-setting-list-label {
    font-weight: 600;
    color: #666;
}

.ai-setting-list-status {
    padding: 2px 6px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 500;
}

.ai-setting-list-status.active {
    background: #d4edda;
    color: #155724;
}

.ai-setting-list-status.inactive {
    background: #f8d7da;
    color: #721c24;
}

.ai-setting-list-timestamp {
    font-size: 11px;
    color: #999;
    margin-top: 8px;
    text-align: right;
}

.ai-setting-list-card-actions {
    display: flex;
    gap: 6px;
    padding: 12px 16px;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    flex-shrink: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .ai-setting-list-container {
        padding: 12px;
    }

    .ai-setting-list-header {
        flex-direction: column;
        gap: 12px;
        align-items: stretch;
    }

    .ai-setting-list-grid {
        grid-template-columns: 1fr;
    }

    .ai-setting-list-card-actions {
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .ai-setting-list-header h3 {
        font-size: 18px;
        text-align: center;
    }

    .ai-setting-list-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
    }
}`, "",{"version":3,"sources":["webpack://./react/features/ai_setting/components/web/ai-setting-list.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,qDAAqD;IACrD,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;AACJ","sourcesContent":["/* AI Setting List Styles (Welcome Page) */\n\n.ai-setting-list-container {\n    max-width: 100%;\n    height: 100%;\n    padding: 20px;\n    background: #f8f9fa;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* Header */\n.ai-setting-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    padding: 16px 20px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    flex-shrink: 0;\n}\n\n.ai-setting-list-header h3 {\n    margin: 0;\n    color: #333;\n    font-size: 20px;\n}\n\n/* Buttons */\n.ai-setting-list-button {\n    padding: 8px 16px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.ai-setting-list-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.ai-setting-list-button--primary {\n    background: #007bff;\n    color: white;\n}\n\n.ai-setting-list-button--primary:hover:not(:disabled) {\n    background: #0056b3;\n}\n\n.ai-setting-list-button--view {\n    background: #17a2b8;\n    color: white;\n    padding: 6px 12px;\n    font-size: 12px;\n}\n\n.ai-setting-list-button--view:hover:not(:disabled) {\n    background: #138496;\n}\n\n.ai-setting-list-button--edit {\n    background: #28a745;\n    color: white;\n    padding: 6px 12px;\n    font-size: 12px;\n}\n\n.ai-setting-list-button--edit:hover:not(:disabled) {\n    background: #1e7e34;\n}\n\n.ai-setting-list-button--delete {\n    background: #dc3545;\n    color: white;\n    padding: 6px 12px;\n    font-size: 12px;\n}\n\n.ai-setting-list-button--delete:hover:not(:disabled) {\n    background: #c82333;\n}\n\n/* Error and Loading States */\n.ai-setting-list-error {\n    background: #f8d7da;\n    color: #721c24;\n    padding: 16px;\n    border-radius: 6px;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.ai-setting-list-retry {\n    background: #dc3545;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.ai-setting-list-loading {\n    text-align: center;\n    padding: 40px 20px;\n    background: white;\n    border-radius: 8px;\n}\n\n.ai-setting-list-spinner {\n    width: 30px;\n    height: 30px;\n    border: 3px solid #f3f3f3;\n    border-top: 3px solid #007bff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 0 auto 12px;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.ai-setting-list-empty {\n    text-align: center;\n    padding: 40px 20px;\n    background: white;\n    border-radius: 8px;\n    color: #666;\n}\n\n.ai-setting-list-empty-icon {\n    font-size: 36px;\n    margin-bottom: 12px;\n}\n\n/* Scrollable content wrapper */\n.ai-setting-list-content-wrapper {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e0 #f8f9fa;\n}\n\n.ai-setting-list-content-wrapper::-webkit-scrollbar {\n    width: 8px;\n}\n\n.ai-setting-list-content-wrapper::-webkit-scrollbar-track {\n    background: #f8f9fa;\n}\n\n.ai-setting-list-content-wrapper::-webkit-scrollbar-thumb {\n    background-color: #cbd5e0;\n    border-radius: 4px;\n}\n\n.ai-setting-list-content-wrapper::-webkit-scrollbar-thumb:hover {\n    background-color: #a0aec0;\n}\n\n/* Settings Grid */\n.ai-setting-list-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 16px;\n    padding-bottom: 20px;\n}\n\n.ai-setting-list-card {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.ai-setting-list-card:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.ai-setting-list-card-header {\n    padding: 16px;\n    border-bottom: 1px solid #e9ecef;\n    background: #f8f9fa;\n}\n\n.ai-setting-list-card-header h4 {\n    margin: 0;\n    color: #333;\n    font-size: 16px;\n}\n\n.ai-setting-list-card-content {\n    padding: 16px;\n    flex: 1;\n    overflow-y: auto;\n}\n\n.ai-setting-list-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    font-size: 13px;\n}\n\n.ai-setting-list-label {\n    font-weight: 600;\n    color: #666;\n}\n\n.ai-setting-list-status {\n    padding: 2px 6px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 500;\n}\n\n.ai-setting-list-status.active {\n    background: #d4edda;\n    color: #155724;\n}\n\n.ai-setting-list-status.inactive {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.ai-setting-list-timestamp {\n    font-size: 11px;\n    color: #999;\n    margin-top: 8px;\n    text-align: right;\n}\n\n.ai-setting-list-card-actions {\n    display: flex;\n    gap: 6px;\n    padding: 12px 16px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    flex-shrink: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .ai-setting-list-container {\n        padding: 12px;\n    }\n\n    .ai-setting-list-header {\n        flex-direction: column;\n        gap: 12px;\n        align-items: stretch;\n    }\n\n    .ai-setting-list-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .ai-setting-list-card-actions {\n        justify-content: center;\n    }\n}\n\n@media (max-width: 480px) {\n    .ai-setting-list-header h3 {\n        font-size: 18px;\n        text-align: center;\n    }\n\n    .ai-setting-list-info {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 2px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
